import React, {Suspense, useEffect, useRef, useState} from 'react';
import NewWindow from 'react-new-window'
import Webgl from "./webgl";
import ReactDOM from 'react-dom';
import App2 from './App2';

import {
    Box,
    Button, Checkbox,
    Container,
    FormControl, FormControlLabel, FormGroup,
    Grid, InputLabel,
    MenuItem,
    Select,
    Slider,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import Grid3x3Icon from '@mui/icons-material/Grid3x3';
import Grid4x4Icon from '@mui/icons-material/Grid4x4';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import {
    Check,
    CheckCircle,
    CloseRounded, DangerousRounded, Home, HomeMaxRounded,
    Login,
    Logout,
    OpenInBrowser,
    SettingsApplicationsRounded, UnpublishedRounded
} from "@mui/icons-material";
import SelectInput from "@mui/material/Select/SelectInput";

const App = () => {
    const videoRef = useRef(null);
    const isScreenCaptureSupported = !!navigator.mediaDevices.getDisplayMedia;
    const [inputLink, setInputLink] = useState("");
    const [inputGap, setInputGap] = useState(10);
    const [inputAmp, setInputAmp] = useState(10);
    const [inputTiles, setInputTiles] = useState(10);
    const [BG, setBG] = useState(true);

    const [popupWindows, setPopupWindows] = useState([]); // Array to store popup windows

    const [exampleUrl, setExampleUrl] = useState("");

    const createPopup = () => {
        const newPopupWindows = [...popupWindows]; // Create a copy of the array
        newPopupWindows.push(
            <NewWindow
                key={newPopupWindows.length} // Use a unique key for each popup
                features={{ width: 1200, height: 800 }}
                url={window.location.href}
            />
        );
        setPopupWindows(newPopupWindows); // Update the state with the new array of popup windows
        ReactDOM.render(newPopupWindows[newPopupWindows.length-1], document.getElementById("popup"));
    };



    /*
    const createPopup = () => {
        let popup = <NewWindow
            features={{width: 1200, height: 800 }}
            url={window.location.href}
        >
        </NewWindow>;
        ReactDOM.render(popup, document.getElementById("popup"));
    };
*/

    const handleGap = (event) => {
       setInputGap(event.target.value);
    }

    const handleAmp = (event) => {
        setInputAmp(event.target.value);
    }

    const handleTiles = (event) => {
        setInputTiles(event.target.value);
    }

    const handleCapture = async () => {

        document.getElementById("options").style.display = "none";

        if (isScreenCaptureSupported) {
            try {

                const supportedConstraints = navigator.mediaDevices.getSupportedConstraints();
                const displayMediaOptions = {
                    video: {},
                    audio: false,
                };

                if (supportedConstraints.logicalSurface) {
                    displayMediaOptions.video.logicalSurface = "monitor";
                }

                const stream = await navigator.mediaDevices.getDisplayMedia(displayMediaOptions);
                videoRef.current.srcObject = stream;
            } catch (error) {
                console.error('Error accessing screen capture:', error);
            }
        } else {
            console.error('Screen Capture API is not supported in this browser.');
        }
    };

    const closeOptions = () => {
        document.getElementById("options").style.display = "none";
    };

    const openOptions = () => {
        document.getElementById("options").style.display = "flex";
    };

    const backHome = () => {
        window.location = "../";
    };

    const handleBG = (event) => {
        setBG(event.target.checked);
    };


    var content =
        <div style={{ overflow: "hidden" }}>
            <Box position={"absolute"}
                 display="flex"
                 justifyContent="center"
                 alignItems="center"

                 minHeight="100vh"
                 minWidth={"100vw"}
                 top={"-80px"}
            >
                <video id="cap" ref={videoRef} controls autoPlay style={{position: "absolute", width: "1600px", height:"1200px", visibility:"hidden"}}/>
                <Webgl gapsize={inputGap} ampsize={inputAmp} tiles={inputTiles} bg={BG} capref={videoRef} />
                <div id={"popup"}></div>
            </Box>

            <SettingsApplicationsRounded
                color="primary"
                onClick={openOptions}
                cursor={"pointer"}
                sx={{position:"absolute", right:"20px", top:"20px"}}
            />

            <Home
                color="primary"
                onClick={backHome}
                cursor={"pointer"}
                sx={{position:"absolute", left:"20px", top:"20px"}}
            />

            <Grid
                id={"options"}
                container
                spacing={4}
                justifyContent={"center"}
                flexDirection={"row"}
                padding={"10px"}
                paddingBottom={"50px"}
                position={"absolute"}
                marginTop={"10px"}
                style={{ backgroundColor: '#ffffff' }}
            >
                <Grid item>
                    <Box
                        display="flex"
                        flexDirection={"column"}
                        rowGap={"10px"}
                        justifyContent="left"
                        alignItems="left"
                        maxWidth={"240px"}
                        style={{
                            position:"absolute",
                            marginLeft:"-270px",
                            borderRight:"solid 1px darkgrey"}}
                    >
                        <Typography variant="h7" color={"primary"}>
                            <b>Step 1:</b> Provide a Youtube Link
                        </Typography>
                        <Typography variant="h7" color={"primary"}>
                            <b>Step 2:</b> Press Enter for Popup
                        </Typography>
                        <Typography variant="h7" color={"primary"}>
                            <b>Step 3:</b> Click 'CAPTURE NOW!'
                        </Typography>
                        <Typography variant="h7" color={"primary"}>
                            <b>Step 4:</b> Choose the Window to Capture (Caution! In Firefox the Window has to be visible)
                        </Typography>
                        <Typography variant="h7" color={"primary"}>
                            <b>Step 5:</b> Enjoy!
                        </Typography>
                    </Box>

                    <Box
                        display="flex"
                        flexDirection={"column"}
                        rowGap={"20px"}
                        justifyContent="center"
                        alignItems="center"
                        maxWidth={"20vw"}
                    >
                        <FormControl fullWidth>
                            <InputLabel id="examples-label">Examples</InputLabel>
                            <Select
                                labelId="examples-label"
                                id="examples"
                                value={exampleUrl}
                                label="Examples"
                                onChange={function(event){
                                    setExampleUrl(event.target.value);
                                    setInputLink(event.target.value);
                                    localStorage.setItem('videolink', event.target.value);
                                }}>
                                <MenuItem value={"https://www.youtube.com/watch?v=mLa0-sQg1YM"}>Deftones - Minerva</MenuItem>
                                <MenuItem value={"https://www.youtube.com/watch?v=4qlCC1GOwFw"}>Linkin Park - One Step Closer</MenuItem>
                                <MenuItem value={"https://www.youtube.com/watch?v=znEH0X8wr3Q"}>P.O.D - Lost In Forever</MenuItem>
                                <MenuItem value={"https://www.youtube.com/watch?v=7qrRzNidzIc"}>Breaking Benjamin - I Will Not Bow</MenuItem>
                                <MenuItem value={"https://www.youtube.com/watch?v=ogMNV33AhCY"}>Pendulum - Witchcraft</MenuItem>
                                <MenuItem value={"https://www.youtube.com/watch?v=tuhe1CpHRxY"}>KNOWER - I'm The President</MenuItem>
                                <MenuItem value={"https://www.youtube.com/watch?v=YSFa_wOZPXg"}>Paramore - The News</MenuItem>
                                <MenuItem value={"https://www.youtube.com/watch?v=qw2LU1yS7aw"}>Slipknot - Before I Forget</MenuItem>
                            </Select>
                        </FormControl>

                        <TextField
                            label={"Youtube Link"}
                            helperText={"PRESS ENTER to open a new Popup. (Make sure your browser allows Popups)"}
                            style={{backgroundColor: "white", borderRadius: "5px", width: "100%"}}
                            onKeyUp={(event) => {
                                if (event.key === "Enter"){
                                    createPopup();
                                }}}
                            value={inputLink}
                            onChange={(event) => {
                                setInputLink(event.target.value);
                                localStorage.setItem('videolink', event.target.value);
                            }}
                        ></TextField>

                        <Button variant="contained" onClick={handleCapture}>
                            Capture Now!
                        </Button>
                    </Box>
                </Grid>
                <Grid item>
                    <Box
                        display="flex"
                        flexDirection={"column"}
                        rowGap={"10px"}
                        justifyContent="left"
                        alignItems="left"
                        maxWidth={"340px"}
                        style={{
                            position:"absolute",
                            marginLeft:"320px",
                            borderLeft:"solid 1px darkgrey",
                            padding:"10px",
                       }}
                    >
                        <Typography variant="h7" color={"primary"}>
                            <b>Optional Step:</b> Tweek the Parameters for some Fancy Video FX!
                        </Typography>

                        <Typography variant="h7" color={"primary"}>
                            <b>Supported Browsers:</b>
                        </Typography>

                        <Grid container spacing={"10"} wrap='nowrap'>
                            <Grid item>
                                <img width="50px" height="50px" src={"https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Google_Chrome_icon_%28February_2022%29.svg/1024px-Google_Chrome_icon_%28February_2022%29.svg.png"}/>
                                <CheckCircle style={{position:"absolute", marginLeft:"-20px", marginBottom:"-10px"}}/>
                            </Grid>
                            <Grid item>
                                <img width="50px" height="50px" src={"https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Opera_2015_icon.svg/1024px-Opera_2015_icon.svg.png"}/>
                                <CheckCircle style={{position:"absolute", marginLeft:"-20px", marginBottom:"-10px"}}/>
                            </Grid>
                            <Grid item>
                                <img width="50px" height="50px" src={"https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Firefox_logo%2C_2019.svg/1024px-Firefox_logo%2C_2019.svg.png"}/>
                                <UnpublishedRounded style={{position:"absolute", marginLeft:"-20px", marginBottom:"-10px"}}/>
                            </Grid>
                            <Grid item>
                                <img width="50px" height="50px" src={"https://upload.wikimedia.org/wikipedia/de/5/58/Safari_Logo.png"}/>
                                <DangerousRounded style={{position:"absolute", marginLeft:"-20px", marginBottom:"-10px"}}/>
                            </Grid>

                        </Grid>
                    </Box>
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width={"300px"}
                        flexDirection={"column"}
                    >
                        <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
                            <CloseFullscreenIcon color="primary"/>
                            <Slider sx={{width: "200px"}} value={inputGap} onChange={handleGap}></Slider>
                            <OpenInFullIcon color="primary"/>
                        </Stack>

                        <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
                            <Login color="primary"/>
                            <Slider sx={{width: "200px"}} value={inputAmp} onChange={handleAmp}></Slider>
                            <Logout color="primary"/>
                        </Stack>

                        <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
                            <Grid3x3Icon color="primary"/>
                            <Slider sx={{width: "200px"}} value={inputTiles} onChange={handleTiles}></Slider>
                            <Grid4x4Icon color="primary"/>
                        </Stack>

                        <FormGroup>
                            <FormControlLabel control={<Checkbox defaultChecked />} label="Enable Background" onChange={handleBG} checked={BG}/>
                        </FormGroup>
                    </Box>
                </Grid>
                <CloseRounded
                    color="primary"
                    onClick={closeOptions}
                    cursor={"pointer"}
                    sx={{position:"absolute", right:"20px"}}
                />
            </Grid>
        </div>;

    document.body.style.backgroundColor = "black";
    document.body.style.overflow = "hidden";
    function checkPopup(){
        var parent_window = window.opener;
        if(!parent_window){
            return;
        }
        document.title = "-> Capture <-";
        content = <App2/>;
    }

    checkPopup();

    return (
        content
    );
}


export default App;